module.exports = {
	"OceanDragon": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクに移動しレジェンドペットとクリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーにも<br />クリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* 報酬：クリスタル1,000個 + トルネード青龍",
		"mission": "<strong>MISSION!</strong> リレー脱出第一章のEp.1-5に到達!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない“お休み中“の状態から復帰したユーザー"
	},
	"2ndAnniversary": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクに移動しレジェンドペットとクリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーにも<br />クリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* 報酬：クリスタル2,222個 + トルネード青龍",
		"mission": "<strong>MISSION!</strong> リレー脱出第一章のEp.1-5に到達!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"MoonLight": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてレジェンドクッキーとクリスタルを受け取ろう!!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーにも<br />クリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* 報酬：クリスタル1,000個 + ムーンライト魔術師クッキー",
		"mission": "<strong>MISSION!</strong> リレー脱出第一章のEp.1-5に到達!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"FireSpirit": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてレジェンドクッキーとクリスタルを受け取ろう!!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーにも<br />クリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* ギフト : 1,000クリスタル + 炎の精霊クッキー",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"RainbowCube": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしレインボーキューブ&クリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーにも<br />クリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* ギフト：クリスタル3,000個 + レインボーキューブ1,000個",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"JellySkin": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしレインボーキューブ&クリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規ユーザーにも復帰ユーザーにもクリスタルとレインボーキューブをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* ギフト：クリスタル3,000個 + レインボーキューブ1,000個",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"Yeti": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてレジェンドペットとクリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規ユーザーと復帰ユーザーどちらにもレジェンドペットとクリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* プレゼント：1,000クリスタル + 雪玉イエティ",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"DreamCatcher": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてレジェンドペットとクリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規ユーザーと復帰ユーザーどちらにもレジェンドペットとクリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* 報酬 : 1,000クリスタル + スタードリームキャッチャー",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"WaveDrop": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてレジェンドペットとクリスタルをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規ユーザーと復帰ユーザーどちらにもレジェンドペットとクリスタルをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* 報酬 : 1,000クリスタル + 波の雫",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	},
	"JellySkin02": {
		"title": "クッキーラン : オーブンブレイク",
		"description": "リンクをタップしてクリスタルとスペースドーナツをGET!",
		"gift": "さんからギフトが届きました。",
		"gift_no_name": "新規&復帰ユーザーどちらにもクリスタルと<br />スペースドーナツ&ペットをプレゼント!",
		"download_now": "クッキーラン：オーブンブレイクをお持ちではありませんね？<br>今すぐダウンロード！",
		"how_to_get_reward": "受け取り方法",
		"install_cro": "クッキーラン：オーブンブレイクをインストール",
		"claim_reward": "「ギフトを受け取る」をタップ",
		"rewards": "* プレゼント：1,000クリスタル +<br />スペースドーナツx20&ペットx20",
		"mission": "<strong>ミッション!</strong> 競技場に入場する!",
		"condition": "報酬対象：新規/復帰ユーザーのみ",
		"new_player": "* 新規ユーザー : 本イベント期間中にクッキーランを初めてスタートするユーザー",
		"old_player": "* 復帰ユーザー : 30日以上、接続のない”お休み中”の状態から復帰したユーザー"
	}
};